/** @jsxImportSource @emotion/react */
'use memo'

import styled from '@emotion/styled'
import colors from '@sportninja/common/constants/appColors'
import type { OrgRegistrationVenue } from '@sportninja/common/features/organization/registration/types'
import { paragraphSmall, paragraphXSmall } from 'src/components/css'
import OrgRegistrationVenueLink from '../../OrgRegistrationVenueLink'

interface Props {
  venues: OrgRegistrationVenue[]
}

/**
 * Where it's played, in two lines at most: one venue over its city, two
 * venues, or the first and "+N more" (the open row lists them all). Each
 * venue opens the map. A dash without venues.
 */
const LocationCell = ({ venues }: Props) => {
  'use memo'

  const [first, second] = venues
  if (!first) {
    return <Wrapper>—</Wrapper>
  }
  const others = venues.length - 1

  return (
    <Wrapper>
      <OrgRegistrationVenueLink venue={first} />
      {venues.length === 1 && first.place ? (
        <SecondLine>{first.place}</SecondLine>
      ) : null}
      {venues.length === 2 && second ? (
        <OrgRegistrationVenueLink venue={second} />
      ) : null}
      {venues.length > 2 ? (
        <SecondLine
          title={venues
            .slice(1)
            .map((venue) => venue.name)
            .join(', ')}
        >
          +{others} more
        </SecondLine>
      ) : null}
    </Wrapper>
  )
}

export default LocationCell

const Wrapper = styled.div`
  ${paragraphSmall}
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  height: 100%;
  color: ${colors.WHITE};
`

// Under the pin's width, so it lines up with the venue name above.
const SecondLine = styled.span`
  ${paragraphXSmall}
  padding-left: 22px;
  white-space: nowrap;
  color: ${colors.NEUTRAL_50};
`
